import { fetchBannerGroup } from 'actions/ContentActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import React, { useEffect } from 'react'
import ContentfulBannerGroup from '../pages/ContentfulWebPage/ContentfulBannerGroup'
import ErrorBoundary from 'components/Common/ErrorBoundary'

interface Props {
  slug: string
}

function ComponentBannerGroup(props: Props) {
  const { slug } = props
  const dispatch = useAppDispatch()
  const region = useAppSelector((state) => state.geo.currentRegionCode.toUpperCase())

  useEffect(() => {
    dispatch(fetchBannerGroup(`${region}-${slug}`))
  }, [dispatch, region, slug])

  const bannerGroup = useAppSelector((state) => state.content.bannerGroup[`${region}-${slug}`])

  if (!bannerGroup) {
    return
  }

  return (
    <ErrorBoundary fallback={null}>
      <ContentfulBannerGroup {...bannerGroup} />
    </ErrorBoundary>
  )
}

export default ComponentBannerGroup
